/**
 * Marinovel 品牌 - Member 页面配置
 */
import { memberCommonConfig } from './common'
import type { MemberPageConfig } from './types'

export const theme = {
  avatarBorder: '#EEF4FF',
  btnPrimaryBg: '#EEF4FF',
  vipSubscribeBg: 'url(/images/marinovel/member_subscribe_bg.webp)',
  userNameColor: '#323435',
  userIdColor: '#9296A0',
} as const

export const resources = {
  userBg: '/images/marinovel/bg.png',
  userDefaultAvatar: '/images/marinovel/user-default.png',
  memberVip: '/images/marinovel/member-vip.png',
  memberVipDiscount: '/images/marinovel/member-vip-discount.png',
} as const

export const memberConfig: MemberPageConfig = {
  theme,
  resources,
  texts: memberCommonConfig.texts,
  showLoginBtn: false,
  menuIcons: {
    wallet: '/images/marinovel/member/icon-wallet.png',
    transaction: '/images/marinovel/member/icon-transaction.png',
    unlocked: '/images/marinovel/member/icon-unlock.png',
    contactUs: '/images/marinovel/member/icon-contact.png',
    setting: '/images/marinovel/member/icon-setting.png',
  },
}
